import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const ContentUsers = styled.div`
  width: 42em;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, 13em);
  height: 7em;
  background: ${({ theme }) => theme.background.light};
  margin-top: 1em;
  padding: 1em;
  text-align: center;
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    width: auto;
    height: 20em;
  }
`;
export const ContentStatistics = styled.div`
  span:nth-child(1) {
    color: rgba(0, 175, 155, 1);
    font-size: 24px;
  }
  span:nth-child(3) {
    font-size: 13px;
  }
`;
